export default "__VITE_ASSET__Ce6qVNYa__"